import { Stack, styled, Typography, Theme } from '@mui/material';
import { useTranslation } from 'react-i18next';

import stationRequestBg from '@images/station-request-slide-bg.webp';

const StyledImg = styled('img')(() => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  objectFit: 'cover',
  zIndex: -1,
}));

export const StationRequestSlide = () => {
  const { t } = useTranslation();
  return (
    <Stack
      sx={(theme: Theme) => ({
        height: '132px',
        width: '100%',
        position: 'relative',
        borderRadius: '10px',
        overflow: 'hidden',
        border: `1px solid ${theme.palette.green.main}`,
      })}
    >
      <Stack sx={{ padding: '25px 18px', maxWidth: 'calc(100% - 90px)' }}>
        <Typography
          variant="body1"
          color="green.main"
          sx={{ fontSize: '22px', textAlign: 'left', lineHeight: '120%' }}
        >
          {t('cabinetPage.slider.slider1_title')}
        </Typography>
        <Typography
          variant="body2"
          color="common.white"
          sx={{ fontSize: '14px', textAlign: 'left', lineHeight: '120%' }}
        >
          {t('cabinetPage.slider.slider1_description')}
        </Typography>
      </Stack>
      <StyledImg src={stationRequestBg} alt="stationRequestBg" />
    </Stack>
  );
};
